import type { LearnerProfileData } from '~/gql/users/learner-profile'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import ProfileSection from './ProfileSection'

/** Les groupes du compte (#242). */
function ProfileGroups({ groups }: { groups: LearnerProfileData['groups'] }) {
  const { t } = useTranslation()

  return (
    <ProfileSection title={t('common.groups')} anchor="profile.groups">
      {groups.length === 0
        ? <p className="text-sm text-muted-foreground">{t('profile.groups.empty')}</p>
        : (
            <ul className="flex flex-wrap gap-2">
              {groups.map(group => (
                <li key={group.id}><Badge variant="outline">{group.name}</Badge></li>
              ))}
            </ul>
          )}
    </ProfileSection>
  )
}

export default ProfileGroups
